import { HttpInterceptorFn, HttpResponse } from '@angular/common/http'
import { tap } from 'rxjs/operators'

import { environment } from '@env'

export const debugInterceptor: HttpInterceptorFn = (req, next) => {
	if (environment.production) return next(req)

	const headers: Record<string, string> = {}
	req.headers.keys().forEach(key => (headers[key] = req.headers.get(key)!))

	let body: unknown = req.body
	if (typeof body === 'string') {
		try {
			body = JSON.parse(body)
		} catch {
			/* keep as string */
		}
	}

	console.group(`[HTTP] ${req.method} ${req.url}`)
	console.log({ url: req.url, method: req.method, headers, body })
	console.groupEnd()

	return next(req).pipe(
		tap({
			next: event => {
				if (event instanceof HttpResponse) {
					console.group(`[HTTP RESPONSE] ${req.method} ${req.url}`)
					console.log({ status: event.status, body: event.body })
					console.groupEnd()
				}
			},
			error: err => console.error(`[HTTP ERROR] ${req.method} ${req.url}`, err),
		})
	)
}
